<template>
    <div>
        <checkbox :status="is_active" @changeStatus="changeStatus($event, name, index)"></checkbox>
        <div v-if="shouldShowPaya">
            <checkbox :id="'id'+name" :status="is_paya_active"
                      @changeStatus="changePayaStatus($event, name, index)">
                {{ $t('label.paya_activation') }}
            </checkbox>
        </div>
    </div>
</template>

<script>
import Checkbox from "@/views/settlement/component/checkbox.vue";
import {i18n} from "@/plugins/i18n";
import {walletService} from "@/common/api.service";
import {bankId} from "@/constants/bankId";

export default {
    name: "AdminBanksActivationCheckboxes",
    components: {Checkbox},
    data() {
        return {
            allowed_paya_banks : [
                'saman',
                'ayande',
                'keshavarzi',
                'saderat',
                'melli',
            ],
        }
    },
    props: {
        bank_status: {
            required: true,
        },
        name:{
            required: true
        },
        index: {
            required: true
        },

        fetch_starshop: {
            default: false,
            type: Boolean
        },
    },
    computed: {
        is_active: {
            get() {
                return this.bank_status.is_active;
            },
            set(val) {
                this.bank_status.is_active = val;
            }
        },
        is_paya_active: {
            get() {
                return this.bank_status.is_paya_active;
            },
            set(val) {
                this.bank_status.is_paya_active = val;
            }
        },
        shouldShowPaya(){
            return Boolean(this.is_active) === true && this.allowed_paya_banks.includes(this.name);
        }
    },
    methods:{
        changePayaStatus(val, name) {
            let message = val
                ? i18n.t('message.are_you_sure_to_enable_this_bank')
                : i18n.t('message.are_you_sure_to_disable_this_bank');

            let answer = confirm(message);

            if (!answer) {
                return false;
            }

            const changePayaStatus = this.fetch_starshop
                ? walletService.changeStarShopBankPayaStatus
                : walletService.changeBankPayaStatus;

            changePayaStatus(`${bankId[name]}?active=${val}`).then((response) => {
                this.toastr.success(response.data.message);
                this.is_paya_active = val;
            });
        },
        changeStatus(val, name) {
            let message = val
                ? i18n.t('message.are_you_sure_to_enable_this_bank')
                : i18n.t('message.are_you_sure_to_disable_this_bank');

            let answer = confirm(message);

            if (!answer) {
                return false;
            }
            let changeBankStatus = this.fetch_starshop
                ? walletService.changeStarShopBankStatus
                : walletService.changeBankStatus;

            changeBankStatus(`${bankId[name]}?active=${val}`).then((response) => {
                this.toastr.success(response.data.message);
                this.is_active = val;
                console.log(this.shouldShowPaya)
            });
        },
    }
}
</script>

<style scoped>

</style>